import { ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';

import { DonutTier } from '../../../tier';
import {
  SkeletonLayout,
  SkeletonLegendList,
  SkeletonLegendRow,
  SkeletonRing,
  SkeletonRingWrapper,
  SkeletonTick,
} from '../styles';

const LEGEND_TEXT_WIDTHS = [80, 70, 90, 65, 75, 60, 70, 55];

interface DonutSkeletonProps {
  tier: DonutTier;
}

export function DonutSkeleton({ tier }: Readonly<DonutSkeletonProps>): ReactElement {
  return (
    <SkeletonLayout $tier={tier}>
      <SkeletonRingWrapper>
        <SkeletonRing />
        <SkeletonTick $top="6%" $left="20%" />
        <SkeletonTick $top="26%" $left="-2%" />
        <SkeletonTick $top="68%" $left="-2%" />
        <SkeletonTick $top="78%" $right="6%" $flip />
      </SkeletonRingWrapper>
      <SkeletonLegendList $tier={tier}>
        {LEGEND_TEXT_WIDTHS.map((textWidth, idx) => (
          <SkeletonLegendRow key={idx}>
            <Skeleton width={14} height={14} borderRadius={3} inline />
            <Skeleton width={textWidth} height={12} borderRadius={6} inline />
          </SkeletonLegendRow>
        ))}
      </SkeletonLegendList>
    </SkeletonLayout>
  );
}
